import { format } from "date-fns"

const dateConverter = (date) => {
  return format(new Date(date), 'dd/MM/yyyy')
}

export default dateConverter